/**
 * uniqueCategories function 
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "category"
 * @returns {items[]} // Array of unique "category" attribute values from the input array
 */
const uniqueCategories = (items) => {
    let categories = new Set([]);

    for (const item of items) {
        categories.add(item.category);
    }

    return [...categories];
}

/**
 * uniqueTypes function 
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "segment"
 * @returns {items[]} // Array of unique "segment" attribute values from the input array
 */
const uniqueTypes = (items) => {
    // Make a set of unique values in the items array
    // Im pulling out all the models values by type to show them in the filters
    let types = new Set([]);

    for (const item of items) {
        types.add(item.segment);
    }

    return [...types];
}

/**
 * uniqueTypesArray function
 * @param {string} type // Input string representing a segment type
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "segments" containing an array of objects with an attribute named "name"
 * @returns {items[]} // Array of unique "name" attribute values from the "segments" attribute of objects in the input array where the "name" attribute matches the input "type" string
 */
const uniqueTypesArray = (type, items) => {
    // Make a set of unique values in the items array
    // Im pulling out all the models values by type to show them in the filters
    let types = new Set([]);

    for (const item of items) {
        // console.log(item)
        for (const segment of item.segments) {
            // console.log("serie", segment.name)
            // console.log("type", type)
            types.add(segment.name)

            // if (segment.name.toLowerCase() === type) {
            //     // console.log("match", item)
            //     for (const serie of item.series) {
            //         models.add(serie.name);
            //     }
            // }
        }
    }

    // console.log([...models])

    return [...types];
}

/**
 * uniqueModels function
 * @param {string} type // Input string representing a segment type
 * @param {Items[]} items // Input array of objects, where each object has attributes named "segment" and "serie"
 * @returns {items[]} // Array of unique "serie" attribute values from objects in the input array where the "segment" attribute matches the input "type" string
 */
const uniqueModels = (type, items) => {
    // Make a set of unique values in the items array
    // Im pulling out all the models values by type to show them in the filters
    let models = new Set([]);

    for (const item of items) {
        if (item.segment === type) {
            models.add(item.serie);
        }
    }

    return [...models];
}

/**
 * uniqueModelsArray function
 * @param {string} type // Input string representing a segment type
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "segments" containing an array of objects with an attribute named "name", and an attribute named "series" containing an array of objects with an attribute named "name"
 * @returns {items[]} // Array of unique "name" attribute values from the "series" attribute of objects in the input array where the "name" attribute of a "segment" object matches the input "type" string
 */
const uniqueModelsArray = (type, items) => {
    // Make a set of unique values in the items array
    // Im pulling out all the models values by type to show them in the filters
    let models = new Set([]);

    for (const item of items) {
        for (const segment of item.segments) {
            // console.log("serie", segment.name)
            // console.log("type", type)

            if (segment.name === type) {
                // console.log("match", item)
                for (const serie of item.series) {
                    // console.log(serie)
                    if (serie.segment.name === type) {
                        models.add(serie.name);
                    }
                }
            }
        }
    }

    // console.log([...models])

    return [...models];
}

/**
 * uniqueVersions function
 * @param {string} model // Input string representing a model name
 * @param {Items[]} items // Input array of objects, where each object has attributes named "serie" and "version" containing objects with an attribute named "name"
 * @returns {items[]} // Array of unique "name" attribute values from the "version" attribute of objects in the input array where the "serie" attribute matches the input "model" string
 */
const uniqueVersions = (model, items) => {
    let versions = new Set([]);

    // for (const item of items) {
    //     if (item.serie === model) {
    //         versions.add(item.version)
    //     }
    // }
    for (const item of items) {
        if (item.serie === model) {
            // console.log(item.version)
            versions.add(item.version.name)
        }
    }

    return [...versions]
}

/**
 * uniqueVersionsArray function
 * @param {string} model // Input string representing a model name
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "series" containing an array of objects with an attribute named "name", and an attribute named "versions" containing an array of objects with an attribute named "name"
 * @returns {items[]} // Array of unique "name" attribute values from the "versions" attribute of objects in the input array where the "name" attribute of a "serie" object matches the input "model" string
 */
const uniqueVersionsArray = (model, items) => {
    let versions = new Set([]);

    for (const item of items) {
        for (const serie of item.series) {
            // console.log("serie", serie.name.toLowerCase())
            // console.log("type", model)

            if (serie.name === model) {
                for (const version of item.versions) {
                    // console.log(version)
                    if (version.serie.name === model) {
                        versions.add(version.name);
                    }
                }
            }
        }
    }
    // console.log([...versions])

    return [...versions]
}

/**
 * uniqueVersionsIds function
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "version" containing an object with an attribute named "id"
 * @returns {Number[]} // Array of unique "id" attribute values from the "version" attribute of objects in the input array
 */
const uniqueVersionsIds = (items) => {
    // Create an empty set to store unique "id" attribute values
    let uniqueVersionsIds = new Set([]);

    // Iterate through each item in the input array and add the "id" attribute value of the "version" attribute object to the set
    for (const item of items) {
        uniqueVersionsIds.add(item.version.id)
    }

    // Convert the set to an array and return it
    return [...uniqueVersionsIds];
}


/**
 * uniqueColors function
 * @param {Items[]} items // Input array of objects, where each object has an attribute named "color" containing an object with an attribute named "name"
 * @returns {String[]} // Array of unique "name" attribute values from the "color" attribute of objects in the input array
 */
const uniqueColors = (items) => {
    // Create a new Map object to store unique "name" attribute values as keys and their corresponding "color" attribute objects as values
    const uniqueColorsMap = new Map();

    // Iterate through each item in the input array and add the "name" attribute value of the "color" attribute object as a key in the Map with the corresponding "color" attribute object as its value. Since Map keys must be unique, duplicate keys will overwrite previous keys with the same value.
    items.forEach(item => {
        uniqueColorsMap.set(item.color.name, item.color);
    });

    // Convert the Map values to an array and return it
    const uniqueColors = [...uniqueColorsMap.values()];
    return uniqueColors;
}


/**
 * uniqueTypeCart function
 * @param {string[]} items // Input array of objects, where each object has an attribute named "type"
 * @returns {string[]} // Array of unique "type" attribute values from the objects in the input array
 */
const uniqueTypeCart = (items) => {
    // Create a new Set object to store unique "type" attribute values
    const uniqueTypes = new Set([]);

    // Iterate through each item in the input array and add the "type" attribute value to the set. Since Sets only store unique values, duplicates will be ignored.
    for (const item of items) {
        uniqueTypes.add(item.type)
    }

    // Convert the set to an array and return it
    return [...uniqueTypes]
}


export {
    uniqueModels,
    uniqueModelsArray,
    uniqueVersions,
    uniqueVersionsArray,
    uniqueVersionsIds,
    uniqueColors,
    uniqueTypes,
    uniqueTypesArray,
    uniqueCategories,
    uniqueTypeCart
}